export default __webpack_public_path__ + "static/media/robot.5ea629fa.png";